/**
 * Dossier Store — Manages user's active dossiers/transactions
 */

import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface DossierItem {
  id: string
  label: string
  type: string
  status: 'actif' | 'en_attente' | 'complete' | 'archive'
  progress: number
  actionsRequises: number
  professional?: string
  updatedAt: string
}

interface DossierState {
  dossiers: DossierItem[]
  archivedCount: number

  // Actions
  setDossiers: (dossiers: DossierItem[]) => void
  addDossier: (dossier: DossierItem) => void
  updateDossier: (id: string, updates: Partial<DossierItem>) => void
  removeDossier: (id: string) => void
  clear: () => void
}

export const useDossierStore = create<DossierState>()(
  devtools(
    persist(
      (set) => ({
        dossiers: [],
        archivedCount: 0,

        setDossiers: (dossiers) =>
          set({
            dossiers: dossiers.filter((d) => d.status !== 'archive'),
            archivedCount: dossiers.filter((d) => d.status === 'archive').length,
          }, false, 'setDossiers'),

        addDossier: (dossier) =>
          set(
            (state) => ({ dossiers: [...state.dossiers, dossier] }),
            false, 'addDossier'
          ),

        updateDossier: (id, updates) =>
          set(
            (state) => ({
              dossiers: state.dossiers.map((d) =>
                d.id === id ? { ...d, ...updates } : d
              ),
            }),
            false, 'updateDossier'
          ),

        removeDossier: (id) =>
          set(
            (state) => ({
              dossiers: state.dossiers.filter((d) => d.id !== id),
            }),
            false, 'removeDossier'
          ),

        clear: () => set({ dossiers: [], archivedCount: 0 }, false, 'clear'),
      }),
      {
        name: 'sgrc-dossiers',
        partialize: (state) => ({
          dossiers: state.dossiers,
          archivedCount: state.archivedCount,
        }),
      }
    ),
    { name: 'DossierStore' }
  )
)
